<template>
  <div>
    <b-breadcrumb size="is-large" separator="has-succeeds-separator" aria-label="breadcrumbs">
      <b-breadcrumb-item active>
        {{ $t('global.dashboard') }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <div class="box">
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vehicula tellus non ullamcorper fermentum. Proin aliquet, est vitae lobortis dapibus, ipsum sem semper lorem, vel tempor tellus dui id nulla.</p>
    </div>
    <div class="columns">
      <div class="column">
        <div class="box">
          <h2 class="subtitle">Overview</h2>
          <p>Some overview information goes here...</p>
        </div>
      </div>
      <div class="column">
        <div class="box">
          <h2 class="subtitle">Stats</h2>
          <p>Some statistics go here...</p>
        </div>
      </div>
    </div>
  </div>
</template>
